import api from './instance'

export const createAutofills = async (data: FormData) => {
  const response = await api.post('v1/autofills/create/', data)
  return response
}

export const createUsers = async (data: FormData) => {
  const response = await api.post('v1/users/', data)
  return response
}

export const createForms = async (data: object) => {
  const response = await api.post('v1/forms/create/', data)
  return response
}

export const manageCustomFields = async (data: object) => {
  const response = await api.post('v1/forms/manage-fields/', data)
  return response
}
